module.exports = __webpack_public_path__ + "img/1584.9acc140f.png";